import {Box} from '@mui/material'
import config from 'src/services/config'
import createStyleSheet from 'src/utilities/createStyleSheet'

type AppVersionProps = {
  color?: string
  sideBar?: boolean
  changePassword?: boolean
}

function AppVersion({color, sideBar, changePassword}: AppVersionProps) {
  return (
    <Box sx={[{color: color}, sideBar === true ? styles.versionSideBar : styles.version, changePassword === true ? styles.versionChangePassword : {}]}>
      Versão: {config.version}
    </Box>
  )
}

const styles = createStyleSheet({
  version: {
    zIndex: 20,
    fontSize: 10,
    color: '#98A2B3',
    fontWeight: 500,
    leadingTrim: 'cap-height',
    lineHeight: '100%',
    letterSpacing: '0px',
    paddingBottom: '10px',
  },
  versionSideBar: {
    fontSize: 9,
  },
  versionChangePassword: {
    fontSize: 9,
    position: 'absolute',
    bottom: '2em',
    left: '2em',
  },
})

export default AppVersion
